import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import getters from "./getters";

const envMap = {
  // dev: 'http://10.0.2.150:114', //本地
  dev: "https://mqt-cluster.huaxun.ink/",
  test: "https://mqt-cluster.huaxun.ink/",
  pro: "https://mqt.huaxun.ink/"
};
const env = "pro";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isShowInv:false,
    invComparison: [],
    breadListState: [], // 面包屑列表数据
    token: "MsaZRJcdkx44pEJX5zT8JsWR4D6YGmsw",
    secretKey: "0WX5GIWWeHzJ9JN3", //aes秘钥

    locaname: "", //企业区域

    env: env,
    domain: envMap[env], //域名 测试

    websiteUrlimg: envMap[env] + "storage/", //集群测试图片地址

    // 模拟的user数据
    userInfo: {
      id: null,
      phone: null,
      company_id: null,
      attribution_area: null,
      uuid: null,
      areaDefault: "内蒙古自治区",
      USER_TYPE: null,
      is_admin: null
    },
    msbname: null,
    companyinfo: {
      is_admin: ""
    },
    cacheRouterName: ""
  },
  mutations: {
    setRouterName(state, name) {
      state.cacheRouterName = name;
    },
    setuserinfo(state, userobject) {
      state.userInfo.id = userobject.id;
      state.userInfo.phone = userobject.phone;
      state.userInfo.company_id = userobject.company_id;
      state.userInfo.uuid = userobject.uuid;
      state.userInfo.USER_TYPE = userobject.USER_TYPE;
      state.userInfo.areaDefault = userobject.areaDefault;
      state.companyinfo = userobject.companyinfo;
    },
    breadListMutations(state, list) {
      state.breadListState = list;
    },
    setInvComparison(state, list) {
      state.invComparison=list
    },
    setInv(state, ishow){
      state.isShowInv=ishow
    }
  },
  actions: {},
  modules: {
    user
  },
  getters
});
export { store };


// WEBPACK FOOTER //
// ./src/store/index.js